import { Status } from '@/backend/types'

export const isStatusFinal = (status: Status) => {
  return status !== 'idle' && status !== 'loading'
}
